<p>
  These are the theme colors used across Material Addons components. Active theme: <strong>{{ activeTheme() | uppercase }}</strong>
</p>

<h2>Status Colors</h2>
<div class="color-columns">
  @for (column of statusColumns; track column.title) {
    <div class="color-column">
      <h3>{{ column.title }}</h3>
      @for (swatch of column.swatches; track swatch.variable + swatch.label) {
        <div class="swatch-row clickable" (click)="copyColor(swatch)">
          <div class="swatch-block" [style.background-color]="swatch.value !== 'not set' ? swatch.value : '#eee'"></div>
          <div class="swatch-info">
            <span class="swatch-label">{{ swatch.label }}</span>
            <code class="swatch-value">{{ swatch.value }}</code>
            <code class="swatch-variable">{{ swatch.variable }}</code>
          </div>
        </div>
      }
    </div>
  }
</div>

<h2>M3 Surface Tokens</h2>
<div class="color-columns">
  @for (swatch of surfaceSwatches; track swatch.variable) {
    <div class="swatch-row clickable" (click)="copyColor(swatch)">
      <div class="swatch-block" [style.background-color]="swatch.value !== 'not set' ? swatch.value : '#eee'"></div>
      <div class="swatch-info">
        <span class="swatch-label">{{ swatch.label }}</span>
        <code class="swatch-value">{{ swatch.value }}</code>
        <code class="swatch-variable">{{ swatch.variable }}</code>
      </div>
    </div>
  }
</div>

<h2>Component Tokens</h2>
<div class="color-columns">
  @for (swatch of componentSwatches; track swatch.variable) {
    <div class="swatch-row clickable" (click)="copyColor(swatch)">
      <div class="swatch-block" [style.background-color]="swatch.value !== 'not set' ? swatch.value : '#eee'"></div>
      <div class="swatch-info">
        <span class="swatch-label">{{ swatch.label }}</span>
        <code class="swatch-value">{{ swatch.value }}</code>
        <code class="swatch-variable">{{ swatch.variable }}</code>
      </div>
    </div>
  }
</div>

<h2>Interactive Colors</h2>
<div class="color-columns">
  @for (swatch of interactiveSwatches; track swatch.variable) {
    <div class="swatch-row clickable" (click)="copyColor(swatch)">
      <div class="swatch-block" [style.background-color]="swatch.value !== 'not set' ? swatch.value : '#eee'"></div>
      <div class="swatch-info">
        <span class="swatch-label">{{ swatch.label }}</span>
        <code class="swatch-value">{{ swatch.value }}</code>
        <code class="swatch-variable">{{ swatch.variable }}</code>
      </div>
    </div>
  }
</div>

<h2>Object and Border Colors</h2>
<div class="color-columns">
  @for (swatch of objectBorderSwatches; track swatch.variable) {
    <div class="swatch-row clickable" (click)="copyColor(swatch)">
      <div class="swatch-block" [style.background-color]="swatch.value !== 'not set' ? swatch.value : '#eee'"></div>
      <div class="swatch-info">
        <span class="swatch-label">{{ swatch.label }}</span>
        <code class="swatch-value">{{ swatch.value }}</code>
        <code class="swatch-variable">{{ swatch.variable }}</code>
      </div>
    </div>
  }
</div>

<h2>Alerts</h2>
<p>Live alert components with their themed colors.</p>
<div class="component-color-section">
  @for (row of alertColorRows; track row.label) {
    <div class="component-color-row">
      <div class="component-preview">
        <mad-alert
          [type]="row.label | lowercase"
          [message]="'This is a ' + (row.label | lowercase) + ' alert.'"
          [closeable]="false"
        ></mad-alert>
      </div>
      <div class="color-chips">
        @for (swatch of row.swatches; track swatch.variable + swatch.label) {
          <div class="color-chip clickable" (click)="copyColor(swatch)">
            <div class="chip-block" [style.background-color]="swatch.value !== 'not set' ? swatch.value : '#eee'"></div>
            <div class="chip-info">
              <span class="chip-label">{{ swatch.label }}</span>
              <code class="chip-value">{{ swatch.value }}</code>
              <code class="chip-variable">{{ swatch.variable }}</code>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>

<h2>Buttons</h2>
<p>Live button components with their themed colors.</p>
<div class="component-color-section">
  @for (row of buttonColorRows; track row.label) {
    <div class="component-color-row">
      <div class="component-preview component-preview--button">
        @switch (row.label) {
          @case ('Primary') {
            <mad-primary-button>Primary</mad-primary-button>
          }
          @case ('Outline') {
            <mad-outline-button>Outline</mad-outline-button>
          }
          @case ('Link') {
            <mad-link-button>Link</mad-link-button>
          }
          @case ('Danger') {
            <mad-danger-button>Danger</mad-danger-button>
          }
        }
      </div>
      <div class="color-chips">
        @for (swatch of row.swatches; track swatch.variable + swatch.label) {
          <div class="color-chip clickable" (click)="copyColor(swatch)">
            <div class="chip-block" [style.background-color]="swatch.value !== 'not set' ? swatch.value : '#eee'"></div>
            <div class="chip-info">
              <span class="chip-label">{{ swatch.label }}</span>
              <code class="chip-value">{{ swatch.value }}</code>
              <code class="chip-variable">{{ swatch.variable }}</code>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
